import { useCallback, useState } from "react";
export const useQuizProgress = (quizData) => {
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [currentStep, setCurrentStep] = useState(1);
    const findNextQuestion = useCallback((answerId) => {
        return quizData.quizTransitions.find(({ onAnswerId }) => {
            if (answerId)
                return onAnswerId === answerId;
            return !onAnswerId;
        });
    }, [quizData.quizTransitions]);
    const progressToNextQuestion = useCallback((answerId) => {
        const nextQuestion = findNextQuestion(answerId);
        if (nextQuestion) {
            setCurrentStep((prev) => prev + 1);
            setCurrentQuestion(nextQuestion);
            return true;
        }
        return false;
    }, [findNextQuestion]);
    const initializeProgress = useCallback((previousAnswerId, previousStep) => {
        const firstQuestion = findNextQuestion(previousAnswerId);
        setCurrentQuestion(firstQuestion || null);
        setCurrentStep(previousStep ? previousStep : 1);
    }, [findNextQuestion]);
    return {
        currentQuestion,
        currentStep,
        findNextQuestion,
        progressToNextQuestion,
        initializeProgress,
    };
};
//# sourceMappingURL=useQuizProgress.js.map